import React, {Component} from 'react';

import Icon from 'lib/struct/icon/Icon';
import IconBox from 'lib/struct/icon/IconBox';

import styles from './SaveButton.less';

export const STATE = {
	None: 'none',
	Loading: 'loading',
	Success: 'success',
	Error: 'error'
};

export default class SaveButton extends Component {
	render() {
		const {state, onClick} = this.props;
		const {
			'save-button': saveButtonClass,
			'save-button__col': colClass,
			'save-button__col_state': colStateClass
		} = styles;

		return (
			<span className={saveButtonClass}>
				<span className={colClass}>
					<button className='button green' onClick={e => onClick()}
						disabled={state === STATE.Loading}>
						Сохранить
					</button>
				</span>
				<span className={[colClass, colStateClass].join(' ')}>
					{state === STATE.Loading && (
						<IconBox icon={<Icon name='loading' />}>Загрузка</IconBox>
					)}
					{state === STATE.Success && (
						<IconBox icon={<Icon name='yes' />}>Сохранено</IconBox>
					)}
					{state === STATE.Error && (
						<IconBox icon={<Icon name='cross' />}>Ошибка</IconBox>
					)}
				</span>
			</span>
		);
	}
}